import React, { useState } from "react";
import { Box, Button, Stepper, Step, StepLabel, TextField, Typography, FormControl } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAuth, useLoading, useSnackbar } from "../../Context/Contexts";
import { SalesOrderAutoComplete } from "../../components/AutoComplete/AutoCompletes";
interface Props {
  batchId: number;
  onAdded: () => void;
  cancelWizard: () => void;
}

const AddOrderToBatchWizard: React.FC<Props> = ({ batchId, onAdded, cancelWizard }) => {
  const { t } = useTranslation();
  const { authService } = useAuth();
  const { showLoading, hideLoading } = useLoading();
  const { showSnackbar } = useSnackbar();

  const [step, setStep] = useState(0);
  const [orderNo, setOrderNo] = useState("");

  const next = () => setStep((s) => s + 1);
  const prev = () => setStep((s) => Math.max(s - 1, 0));

  const finish = async () => {
    showLoading();
    try {
      await authService.post("/batchApi/AddOrder", { batchId, orderNo });
      showSnackbar(t("common.orderAddedToBatch"), "success");
      onAdded();
      cancelWizard();
    } catch (error: any) {
      showSnackbar(error.response?.data ?? error.message, "error");
    } finally {
      hideLoading();
    }
  };

  return (
    <Box sx={{ width: "100%", maxWidth: 400 }}>
      <Stepper activeStep={step} sx={{ mb: 3 }} alternativeLabel>
        <Step><StepLabel>{t("common.order")}</StepLabel></Step>
        <Step><StepLabel>{t("common.confirm")}</StepLabel></Step>
      </Stepper>
          {step === 0 && (
              <FormControl fullWidth>
                  <SalesOrderAutoComplete
                              
                                        valueId={orderNo}
                                        onChange={(selected) => {
                                           
                                                setOrderNo(selected?.value ?? "")
                                        
                                        }}
                                        load={true}

                                    />
                                </FormControl>
/*        <TextField label={t("common.orderNo")} value={orderNo} onChange={(e) => setOrderNo(e.target.value)} fullWidth />*/
      )}
      {step === 1 && (
        <Typography>{t("common.confirmAddOrder", { orderNo, batchId })}</Typography>
      )}
      <Box sx={{ mt: 2, display: "flex", justifyContent: "center", gap: 1 }}>
        {step > 0 && <Button onClick={prev}>{t("common.previous")}</Button>}
        {step < 1 && <Button variant="contained" onClick={next} disabled={!orderNo.trim()}>{t("common.next")}</Button>}
        {step === 1 && <Button variant="contained" color="primary" onClick={finish}>{t("common.finish")}</Button>}
        <Button variant="outlined" color="warning" onClick={cancelWizard}>{t("common.cancelWizard")}</Button>
      </Box>
    </Box>
  );
};

export default AddOrderToBatchWizard;
